import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ items }) => {
  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.url) {
            return (
              <Typography
                key={index}
                color="text.primary"
                sx={{ fontWeight: isLast ? 600 : 400 }}
              >
                {item.name}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              to={item.url}
              style={{
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <Typography
                color="text.secondary"
                sx={{
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                {item.name}
              </Typography>
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};
